import React     from "react";

import Header    from '../../components/header';
import Directory from './atoms/directory';
import '../../app.min.css';

class Dashboard extends React.Component {
	constructor (props) {
		super (props);
		this.state = {
			value : 0,
		};
	}

	componentDidMount () {
		document.title = "Dashboard | Overseas.one";
	}

	render (props) {
		return (
			<div className= "container">
				<Header />
				<Directory />
			</div>
		);
	};
}

export default Dashboard;
